// The code in this file will load on every page of your site
import wixLocation from 'wix-location';


let defaultBoxColor = "#F5F5F5"
let hoverColor = "white"
let hoverBorderWidth = "5px"

export function eventsBox_click(event) {
    wixLocation.to("/Events");
}

export function collectionsBox_click(event){
	wixLocation.to("/Collections");
}

export function aboutBox_click(event){
	wixLocation.to("/about-us");
}

export function eventsBox_mouseIn(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 

    let thisObject = $w("#eventsBox");

    thisObject.style.backgroundColor = hoverColor;
    thisObject.style.borderColor = "black";
    thisObject.style.borderWidth = hoverBorderWidth;
}

export function eventsBox_mouseOut(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
    let thisObject = $w("#eventsBox");
    
    thisObject.style.borderColor = defaultBoxColor;
    thisObject.style.backgroundColor = defaultBoxColor;
}

export function collectionsBox_mouseIn(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 

    let thisObject = $w("#collectionsBox");

    thisObject.style.backgroundColor = hoverColor;
    thisObject.style.borderColor = "black";
    thisObject.style.borderWidth = hoverBorderWidth;
}

export function collectionsBox_mouseOut(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 

    let thisObject = $w("#collectionsBox");
    
    thisObject.style.borderColor = defaultBoxColor;
    thisObject.style.backgroundColor = defaultBoxColor;
}

export function aboutBox_mouseIn(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
    let thisObject = $w("#aboutBox");

    thisObject.style.backgroundColor = hoverColor;
    thisObject.style.borderColor = "black";
    thisObject.style.borderWidth = hoverBorderWidth;
}

export function aboutBox_mouseOut(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 

    let thisObject = $w("#aboutBox");
    
    thisObject.style.borderColor = defaultBoxColor;
    thisObject.style.backgroundColor = defaultBoxColor;
}